import {
	COLUMN_ID_CHECKBOX,
	COLUMN_ID_EXPAND_BUTTON,
	COLUMN_ID_MERGED_COLUMN,
} from '@atlassian/jira-issue-table-common/src/constants.tsx';
import { EXPAND_CELL_PADDING } from '../../constants.tsx';
import type { Column } from '../../types.tsx';

/**
 * Calculate the total width of all sticky columns.
 *
 * Note: This function assumes that sticky columns are already sorted to the front
 * of the columns array (as done by getColumnsWithStickyOffsets), so we can break
 * early when we encounter the first non-sticky column.
 */
export const calculateStickyColumnsWidth = (columns: Column[]): number => {
	let totalWidth = 0;

	for (const column of columns) {
		const { id, isColumnSticky, defaultWidth, customWidth } = column;

		if (
			id === COLUMN_ID_CHECKBOX ||
			id === COLUMN_ID_EXPAND_BUTTON ||
			id === COLUMN_ID_MERGED_COLUMN ||
			isColumnSticky
		) {
			if (id === COLUMN_ID_EXPAND_BUTTON) {
				totalWidth += defaultWidth + EXPAND_CELL_PADDING;
			} else {
				totalWidth += customWidth ?? defaultWidth;
			}
		} else {
			break;
		}
	}

	return totalWidth;
};
